export var sizes;
(function (sizes) {
    sizes["small"] = "480";
    sizes["medium"] = "960";
    sizes["large"] = "1920";
})(sizes || (sizes = {}));
export const buildUri = (url, size) => {
    if (String(url).includes("{.width}")) {
        return url.replace("{.width}", `.${size}`);
    }
    return url;
};
//# sourceMappingURL=uriTemplate.js.map